// src/theme/index.js
import { createTheme } from "@mui/material/styles";

import palette from "./palette";
import breakpoints from "./breakpoints";
import getTypography from "./typography";
import getComponents from "./components";

import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";

// 1) Create a "base" theme with palette & breakpoints
let theme = createTheme({
  // If you want a "mode", do: palette: { ...palette, mode: "light" } or similar
  palette,
  breakpoints,
  // example: your custom label setting
  label: {
    textTransform: "none",
  },
});

// 2) Then update the theme with overrides that reference the newly created theme
theme = createTheme(theme, {
  // If you want typography inside the theme object, do:
  typography: getTypography(theme),
  components: getComponents(theme),
});

// Done! Export the final theme
export default theme;
